"use strict";

exports.__esModule = true;
var endpoints = {
  set endpointsRootDomain(endpointsRootDomain) {
    this._endpointsRootDomain = endpointsRootDomain;
  },
  get endpointsRootDomain() {
    return this._endpointsRootDomain;
  },
  get tldAndEnvironment() {
    if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
      return process.env.MOBILE_ENV === 'development' ? ['com', 'demo-owl'] : ['io', 'import'];
    } else {
      return global.location ? global.location.hostname.split('.').reverse().slice(0, 2) : ['io', 'import'];
    }
  },
  get rootDomain() {
    var _a = this.tldAndEnvironment,
      tld = _a[0],
      environment = _a[1];
    return this.endpointsRootDomain || process.env.ENDPOINTS_ROOT_DOMAIN || environment + "." + tld;
  },
  get baseUrl() {
    return process.env.ENDPOINTS_BASE_URL || "https://" + this.rootDomain;
  },
  get apiBaseUrl() {
    return process.env.ENDPOINTS_API_BASE_URL || "https://api." + this.rootDomain;
  },
  get magicBaseUrl() {
    return process.env.ENDPOINTS_MAGIC_BASE_URL || "https://magic." + this.rootDomain;
  },
  get elfBaseUrl() {
    return process.env.ENDPOINTS_ELF_BASE_URL || "https://elf." + this.rootDomain;
  },
  get serviceBaseUrl() {
    return process.env.ENDPOINTS_SERVICE_BASE_URL || "https://service." + this.rootDomain;
  },
  get feedsBaseUrl() {
    return process.env.ENDPOINTS_FEEDS_BASE_URL || "https://feeds." + this.rootDomain;
  },
  get storeBaseUrl() {
    return process.env.ENDPOINTS_STORE_BASE_URL || "https://store." + this.rootDomain;
  },
  get getDataBaseUrl() {
    return process.env.ENDPOINTS_GET_DATA_BASE_URL || "https://get-data." + this.rootDomain;
  },
  get extractionBaseUrl() {
    return process.env.ENDPOINTS_EXTRACTION_BASE_URL || "https://extraction." + this.rootDomain;
  },
  get scheduleBaseUrl() {
    return process.env.ENDPOINTS_SCHEDULE_BASE_URL || "https://schedule." + this.rootDomain;
  },
  get subscriptionBaseUrl() {
    return process.env.ENDPOINTS_SUBSCRIPTION_BASE_URL || "https://subscription." + this.rootDomain;
  },
  get webcacheBaseUrl() {
    return process.env.ENDPOINTS_WEBCACHE_BASE_URL || "https://webcache." + this.rootDomain;
  },
  get runBaseUrl() {
    return process.env.ENDPOINTS_RUN_BASE_URL || "https://run." + this.rootDomain;
  },
  get billingBaseUrl() {
    return process.env.ENDPOINTS_BILLING_BASE_URL || "https://billing." + this.rootDomain;
  },
  get eecBaseUrl() {
    return process.env.ENDPOINTS_EEC_BASE_URL || "https://eec." + this.rootDomain;
  },
  get listProducerBaseUrl() {
    return process.env.ENDPOINTS_LIST_PRODUCER_BASE_URL || "https://list-producer." + this.rootDomain;
  },
  get dashBaseUrl() {
    return process.env.ENDPOINTS_DASH_BASE_URL || "https://dash." + this.rootDomain;
  },
  get lightningBaseUrl() {
    return process.env.ENDPOINTS_LIGHTNING_BASE_URL || "https://lightning." + this.rootDomain;
  },
  get appBaseUrl() {
    return process.env.ENDPOINTS_APP_BASE_URL || "https://app." + this.rootDomain;
  },
  get prxBaseUrl() {
    return process.env.ENDPOINTS_PRX_BASE_URL || "http://prx." + this.rootDomain;
  },
  get securePrxBaseUrl() {
    return process.env.ENDPOINTS_SECURE_PRX_BASE_URL || "https://prx." + this.rootDomain;
  },
  get secureCssPrxBaseUrl() {
    return process.env.ENDPOINTS_SECURE_CSS_PRX_BASE_URL || "https://css-prx." + this.rootDomain;
  },
  get authBaseUrl() {
    return process.env.ENDPOINTS_AUTH_BASE_URL || "https://auth." + this.rootDomain;
  },
  get rssBaseUrl() {
    return process.env.ENDPOINTS_RSS_BASE_URL || "https://rss." + this.rootDomain;
  },
  get autopilotBaseUrl() {
    return process.env.ENDPOINTS_AUTOPILOT_BASE_URL || "http://autopilot." + this.rootDomain;
  },
  get dataBaseUrl() {
    return process.env.ENDPOINTS_DATA_BASE_URL || "https://data." + this.rootDomain;
  },
  get accountBaseUrl() {
    return process.env.ENDPOINTS_ACCOUNT_BASE_URL || "https://account." + this.rootDomain;
  },
  get suggestBaseUrl() {
    return process.env.ENDPOINTS_SUGGEST_BASE_URL || "https://suggest." + this.rootDomain;
  },
  get emailVerificationBaseUrl() {
    return process.env.ENDPOINTS_EMAIL_VERIFICATION_BASE_URL || "https://emailverification." + this.rootDomain;
  },
  get emailSupportBaseUrl() {
    return process.env.ENDPOINTS_EMAIL_SUPPORT_BASE_URL || "https://email-support." + this.rootDomain;
  },
  get dataSuggestBaseUrl() {
    return process.env.ENDPOINTS_DATA_SUGGEST_BASE_URL || "https://data-suggest." + this.rootDomain;
  },
  get maestroBaseUrl() {
    return process.env.ENDPOINTS_MAESTRO_BASE_URL || this.apiBaseUrl + "/maestro";
  },
  get unbounceSignupBaseUrl() {
    return process.env.ENDPOINTS_UNBOUNCE_SIGNUP_BASE_URL || "https://get." + this.rootDomain;
  },
  get unbounceSocialBaseUrl() {
    return process.env.ENDPOINTS_UNBOUNCE_SOCIAL_BASE_URL || "https://try." + this.rootDomain;
  },
  get unbounceContactBaseUrl() {
    return process.env.ENDPOINTS_UNBOUNCE_CONTACT_BASE_URL || "https://contact." + this.rootDomain;
  },
  get workflowBaseUrl() {
    return process.env.ENDPOINTS_WORKFLOW_BASE_URL || "https://workflow." + this.rootDomain;
  },
  get userLeadsBaseUrl() {
    return process.env.ENDPOINTS_USER_LEADS_BASE_URL || "https://userleads." + this.rootDomain;
  },
  get britannicaBaseUrl() {
    return process.env.ENDPOINTS_BRITANNICA_BASE_URL || "https://britannica." + this.rootDomain;
  },
  get commerceBaseUrl() {
    return process.env.ENDPOINTS_COMMERCE_BASE_URL || "https://commerce." + this.rootDomain;
  }
};
exports["default"] = endpoints;